
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M9 5h15l8 8v21a1 1 0 01-1 1H9a1 1 0 01-1-1V6a1 1 0 011-1z","fill":"#FFF"}}),_c('path',{attrs:{"fill":"#CFD6E6","d":"M13 17h14v2H13zM13 21h14v2H13zM13 25h8v2h-8zM24 5l8 8h-7a1 1 0 01-1-1V5z"}})])])
          )
        }
      }
    